import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgTtLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.626 8.576a3.97 3.97 0 003.97 3.96 3.97 3.97 0 003.971-3.96 3.97 3.97 0 00-3.97-3.96 3.97 3.97 0 00-3.971 3.96zM4 8.576C4 4.397 7.408 1 11.596 1c4.189 0 7.597 3.398 7.597 7.575s-3.408 7.576-7.597 7.576C7.408 16.15 4 12.752 4 8.575zm10.509 9.395L11.597 23l-2.912-5.03h5.824z"
        fill="#000"
      />
    </svg>
  );
}

export default tombacIcon('TtLogo')(SvgTtLogo);
